<template>
  <div class="gx-strat">
    <gx-loading :show="isLoading" />
    <div class="gx-strat__row gx-main__title">
      <div class="gx-main__title" style="margin:0 auto 0 0">上架策略</div>
      <button class="gx-strat__btn gx-strat__btn--add" @click="strategryOpen(null)">
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M5.5 1v9M1 5.5h9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" /></svg>
        新增策略
      </button>
      <button class="gx-strat__btn gx-strat__btn--del" :disabled="!ids.length" @click="batchDelStrategry">删除策略<span v-if="ids.length">({{ids.length}})</span></button>
    </div>

    <div class="gx-strat__table">
      <table>
        <thead>
          <tr>
            <th style="width: 36px">
              <div class="gx-strat__check" :class="{ 'gx-strat__check--on': allChecked }" @click="toggleAll">
                <svg v-if="allChecked" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                <div style="width: 7px; height: 1.5px; background: rgb(200, 68, 60); border-radius: 1px;" v-if="ids.length&&!allChecked"></div>
              </div>
            </th>
            <th>策略名称</th>
            <th>创建时间</th>
            <th>是否默认</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in list" :key="row.id">
            <td>
              <span class="gx-strat__check" :class="{ 'gx-strat__check--on': ids.includes(row.id) }" @click="toggleOne(row.id)">
                <svg v-if="ids.includes(row.id)" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
              </span>
            </td>
            <td><span class="gx-strat__name">{{ row.name || '--' }}</span><span v-if="row.is_default" class="gx-strat__default_txt">默认</span></td>
            <td>{{ row.created_at }}</td>
            <td>
              <span class="gx-strat__default" v-if="row.is_default"><span class="gx-strat__default-dot"></span>是</span>
              <span v-else>否</span>
            </td>
            <td>
              <div class="gx-strat__ops">
                <button class="gx-strat__op gx-strat__op--edit" @click="strategryOpen(row)">修改</button>
                <button class="gx-strat__op gx-strat__op--del" @click="delStrategry(row)">删除</button>
              </div>
            </td>
          </tr>
          <tr v-if="!list.length">
            <td :colspan="5" class="gx-strat__empty">暂无策略数据</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 新增/编辑策略弹窗 -->
    <div v-if="formDialog && strategy" class="gx-modal" @click.self="closeMask">
      <div class="gx-modal-box gx-strat__modal-box--lg">
        <div class="gx-modal-head">
          <span class="gx-modal-title">{{ strategy.id ? '编辑策略' : '新增策略' }}</span>
          <button class="gx-modal-close" @click="closeMask">✕</button>
        </div>
        <div class="gx-modal-body custom-el-wrapper">
          <div class="gx-strat__form">
            <div class="gx-strat__field">
              <label class="gx-strat__field-label"><span class="gx-strat__req">*</span>策略名称</label>
              <input v-model="strategy.name" class="gx-strat__field-input" placeholder="请输入" />
            </div>
            <div class="gx-strat__field">
              <label class="gx-strat__field-label">标题前缀</label>
              <input v-model="strategy.title_prefix" class="gx-strat__field-input" placeholder="请输入" />
            </div>
            <div class="gx-strat__field">
              <label class="gx-strat__field-label">默认SKU后缀<span class="gx-strat__field-label--suffix">— 不输入则默认商品原SKU名称</span></label>
              <input v-model="strategy.sku_suffix" class="gx-strat__field-input" placeholder="请输入" />
              <div class="gx-strat__field-tip">示例：颜色分类：黑色（<span class="gx-strat__tip--red">SKU后缀</span>）</div>
            </div>
            <div class="gx-strat__field">
              <label class="gx-strat__field-label"><span class="gx-strat__req">*</span>价格公式</label>
              <div class="gx-strat__formula gx-strat__formula--card">
                <span>原价格</span>
                <span style="font-size: 16px;color: #999;">×</span>
                <div>
                  <div class="gx-strat__formula-input-label">倍数</div>
                  <input type="number" v-model="strategy.price_factor" class="gx-strat__mini-input" />
                </div>
                <el-select v-model="strategy.price_operator" size="small" class="gx-strat__mini-select">
                  <el-option v-for="o in typeOptions" :key="o.value" :value="o.value" :label="o.label"></el-option>
                </el-select>
                <div>
                  <div class="gx-strat__formula-input-label">加价</div>
                  <input type="number" v-model="strategy.price_offset" class="gx-strat__mini-input" />
                </div>
                <span>元</span>
              </div>
              <div class="gx-strat__field-tip">预览：原价格 × {{ strategy.price_factor }} {{strategy.price_operator}} {{ strategy.price_offset }} 元</div>
            </div>
            <div class="gx-strat__field">
              <label class="gx-strat__field-label">运费加到售价</label>
              <div class="gx-strat__postage">
                <div class="gx-strat__postage-row">
                  <label class="gx-strat__radio" :class="{ 'gx-strat__radio--on': strategy.alibaba_non_free_postage_mode === 'fixed' }">
                    <input type="radio" value="fixed" v-model="strategy.alibaba_non_free_postage_mode" @change="handleAlibabaNonFreePostageModeChange" />
                    <span class="gx-strat__radio-dot"></span>
                  </label>
                  <span class="gx-strat__help" title="1、可能存在部分商品识别不到是否包邮，或只针对某些地区包邮的情况，无法保证百分百判定准确，请自行核实后再提交任务。&#10;2、不包邮的判断，是只要有一个城市不包邮，就判定为不包邮。">?</span>
                  <span>若来源商品不包邮，计算后的售卖价 +</span>
                  <input v-model="strategy.alibaba_non_free_postage_amount" class="gx-strat__mini-input" :disabled="strategy.alibaba_non_free_postage_mode !== 'fixed'" />
                  <span>元</span>
                </div>
                <div class="gx-strat__postage-row">
                  <label class="gx-strat__radio" :class="{ 'gx-strat__radio--on': strategy.alibaba_non_free_postage_mode === 'region' }">
                    <input type="radio" value="region" v-model="strategy.alibaba_non_free_postage_mode" @change="handleAlibabaNonFreePostageModeChange" />
                    <span class="gx-strat__radio-dot"></span>
                  </label>
                  <span class="gx-strat__help" title="按1688商品发往所选省份的首件运费计算；无法识别模板时本商品不加运费，仍会继续铺货。">?</span>
                  <span>若来源商品不包邮，计算后的售卖价 +（来源发往</span>
                  <select v-model="strategy.alibaba_region_freight_province_code" class="gx-strat__mini-select gx-strat__mini-select--province" :disabled="strategy.alibaba_non_free_postage_mode !== 'region'">
                    <option v-for="p in provinceOptions" :key="p.value" :value="p.value">{{ p.label }}</option>
                  </select>
                  <span>的运费 ×</span>
                  <input v-model="strategy.alibaba_region_freight_percent" class="gx-strat__mini-input" :disabled="strategy.alibaba_non_free_postage_mode !== 'region'" />
                  <span>% +</span>
                  <input v-model="strategy.alibaba_region_freight_amount" class="gx-strat__mini-input" :disabled="strategy.alibaba_non_free_postage_mode !== 'region'" />
                  <span>元）</span>
                </div>
                <div class="gx-strat__postage-row">
                  <label class="gx-strat__check" :class="{ 'gx-strat__check--on': strategy.alibaba_free_postage_low_price_enabled }">
                    <input type="checkbox" v-model="strategy.alibaba_free_postage_low_price_enabled" />
                    <span class="gx-strat__check-box">
                      <svg v-if="strategy.alibaba_free_postage_low_price_enabled" width="9" height="9" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                    </span>
                  </label>
                  <span class="gx-strat__help" title="SKU价格低于阈值元指的是：只要其中一个SKU价格低于阈值元就算。">?</span>
                  <span>若来源商品包邮，且存在SKU价格低于</span>
                  <input v-model="strategy.alibaba_free_postage_low_price_threshold" class="gx-strat__mini-input" :disabled="!strategy.alibaba_free_postage_low_price_enabled" />
                  <span>元，系统统一加</span>
                  <input v-model="strategy.alibaba_free_postage_low_price_amount" class="gx-strat__mini-input" :disabled="!strategy.alibaba_free_postage_low_price_enabled" />
                  <span>元到商品售价</span>
                </div>
              </div>
            </div>
            <div class="gx-strat__field">
              <label class="gx-strat__field-label"><span class="gx-strat__req">*</span>分角设置</label>
              <div class="gx-strat__radio-group">
                <label v-for="f in fenjiao_options" :key="f.value" class="gx-strat__radio-btn" :class="{ 'gx-strat__radio--on': strategy.rounding_mode === f.value }">
                  <input type="radio" :value="f.value" v-model="strategy.rounding_mode" />
                  <span class="gx-strat__radio-dot"></span>
                  <span>{{ f.label }}</span>
                </label>
              </div>
            </div>
            <div class="gx-strat__field">
              <label class="gx-strat__field-label"><span class="gx-strat__req">*</span>铺货方式</label>
              <div class="gx-strat__radio-group">
                <label v-for="p in puhuo_options" :key="p.value" class="gx-strat__radio-btn" :class="{ 'gx-strat__radio--on': strategy.listing_mode === p.value }">
                  <input type="radio" :value="p.value" v-model="strategy.listing_mode" />
                  <span class="gx-strat__radio-dot"></span>
                  <span>{{ p.label }}</span>
                </label>
              </div>
              <div class="gx-strat__field-warn">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style="flex-shrink: 0; margin-top: 1px;"><circle cx="7" cy="7" r="6" stroke="#FB923C" stroke-width="1.2"></circle>
                  <path d="M7 4v3.5M7 9.5v.5" stroke="#FB923C" stroke-width="1.3" stroke-linecap="round"></path>
                </svg>
                备注：微信小店不支持选择上架到仓库，选择上架仓库会发布到草稿箱
              </div>
            </div>
            <div class="gx-strat__field">
              <label class="gx-strat__field-label">商品SKU设置</label>
              <div class="gx-strat__field-tip" style="margin-top: 0;margin-bottom: 8px;">最多支持5个规格类型</div>
              <button class="gx-strat__btn gx-strat__btn--sm gx-strat__btn--del" :disabled="strategy.spec_types && strategy.spec_types.length >= 5" @click="addSpecType">+新增商品规格类型</button>
              <div v-for="(item, index) in strategy.spec_types" :key="index" class="gx-strat__sku-item" >
<!--                 <template v-if="index<specTypesNum">
                   <div>
                     <div class="gx-strat__sku-head">
                       <span class="gx-strat__sku-title">规格{{ index + 1 }}：</span>
                       <span class="gx-strat__sku-tag">后缀:{{item.sku_suffix}} </span>
                     </div>
                     <div style="font-size: 11px;color: #666;">
                       价格公式: 原×{{item.price_factor}}{{item.price_operator}}{{item.price_offset}} 元&nbsp;·&nbsp;{{fenJiaoLabel(item.rounding_mode)}}
                     </div>
                   </div>
                   <i class="el-icon-close gx-strat__req" style="font-weight: bold;margin-left: auto;" @click="removeSpecType(index);specTypesNum&#45;&#45;"></i>
                 </template>
                 <template v-else>-->
                   <div class="gx-strat__sku-head">
<!--                     <span class="gx-strat__sku-title">新增商品规格类型</span>-->
                     <span class="gx-strat__sku-title">规格{{ index + 1 }}：</span>
                     <i class="el-icon-close gx-strat__req" style="font-weight: bold;margin-left: auto;cursor: pointer" @click="removeSpecType(index);"></i>
                   </div>
                   <div class="gx-strat__sku-row">
                     <span class="gx-strat__sku-label">SKU后缀</span>
                     <input v-model="item.sku_suffix" class="gx-strat__field-input" placeholder="例：（黑色）" />
                   </div>
                   <div class="gx-strat__sku-row">
                     <span class="gx-strat__sku-label">价格公式</span>
                     <div class="gx-strat__formula gx-strat__formula--sm">
                       <span>原价格</span>
                       <span style="font-size: 15px;color: #999;">×</span>
                       <input type="number" v-model="item.price_factor" class="gx-strat__mini-input" />
                       <el-select v-model="item.price_operator" size="small" class="gx-strat__mini-select">
                         <el-option v-for="o in typeOptions" :key="o.value" :value="o.value" :label="o.label"></el-option>
                       </el-select>
                       <input type="number" v-model="item.price_offset" class="gx-strat__mini-input" />
                       <span>元</span>
                     </div>
                   </div>
                   <div class="gx-strat__sku-row">
                     <span class="gx-strat__sku-label">角分设置</span>
                     <div class="gx-strat__sku-radio-group">
                      <span v-for="f in fenjiao_options" :key="f.value" class="gx-strat__sku-radio" :class="{ 'gx-strat__sku-radio--on': item.rounding_mode === f.value }"
                            @click="item.rounding_mode=f.value">
                       {{ f.label }}
                      </span>
                     </div>
                   </div>
<!--                   <div class="gx-strat__sku-row" style="justify-content: flex-end">
                     <button class="gx-strat__btn gx-strat__btn&#45;&#45;sm gx-strat__btn&#45;&#45;cancel" @click="removeSpecType(index)">取消</button>
                     <button class="gx-strat__btn gx-strat__btn&#45;&#45;sm" :class="item.sku_suffix?'gx-strat__btn&#45;&#45;add':'gx-strat__btn&#45;&#45;info'" @click="specTypesNum++">保存规格</button>
                   </div>-->
<!--                 </template>-->
               </div>
            </div>
            <div class="gx-strat__formula--card gx-strat__row">
              <div class="gx-strat__spacer">
                <label class="gx-strat__field-default">是否默认</label>
                <div class="gx-strat__field-tip" style="margin-top: 0;">设为默认后，铺货时将自动应用此策略</div>
              </div>

              <label class="gx-strat__switch">
                <input type="checkbox" v-model="strategy.is_default" />
                <span class="gx-strat__switch-track"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="gx-modal-foot gx-strat__modal-foot">
          <button class="gx-modal-foot-btn" @click="closeMask">取消</button>
          <button class="gx-modal-foot-btn gx-modal-foot-btn--yellow" :disabled="saving" @click="saveEdit">
            {{ saving ? '保存中...' : '保存' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import GxLoading from '../../components/newUi/GxLoading.vue'
import areaData from '@/assets/js/data/area.js'

const MAINLAND_PROVINCE_CODES = ['110000', '120000', '130000', '140000', '150000', '210000', '220000', '230000', '310000', '320000', '330000', '340000', '350000', '360000', '370000', '410000', '420000', '430000', '440000', '450000', '460000', '500000', '510000', '520000', '530000', '540000', '610000', '620000', '630000', '640000', '650000', '710000', '810000', '820000']

export default {
  name: 'NewShelfStrategyPage',
  components: { GxLoading },
  data() {
    return {
      isLoading: false,
      list: [],
      pageData: { limit: 100, page: 1, total: 0 },
      pageSizeOptions: [10, 20, 50, 100, 200],
      ids: [],
      formDialog: false,
      strategy: null,
      init_strategy: {
        id: null,
        name: '',
        title_prefix: '',
        price_factor: 1.00,
        price_operator: '+',
        price_offset: 5.00,
        alibaba_non_free_postage_enabled: true,
        alibaba_non_free_postage_amount: 5.00,
        alibaba_region_freight_enabled: false,
        alibaba_region_freight_province_code: '310000',
        alibaba_region_freight_percent: 100.00,
        alibaba_region_freight_amount: 0.00,
        alibaba_non_free_postage_mode: 'fixed',
        alibaba_free_postage_low_price_enabled: false,
        alibaba_free_postage_low_price_threshold: 5.00,
        alibaba_free_postage_low_price_amount: 3.00,
        rounding_mode: 0,
        listing_mode: 2,
        shippingTime: '48h',
        is_default: false,
        sku_suffix: '',
        spec_types: []
      },
      typeOptions: [
        { label: '+', value: '+' },
        { label: '−', value: '-' }
      ],
      fenjiao_options: [
        { label: '保留分角', value: 0 },
        { label: '抹去分', value: 1 },
        { label: '抹去角', value: 2 }
      ],
      puhuo_options: [
        { label: '上架', value: 0 },
        { label: '放入仓库', value: 1 },
        { label: '放入草稿箱', value: 2 }
      ],
      provinceOptions: MAINLAND_PROVINCE_CODES.map(value => ({ value, label: areaData.province_list[value] })),
      saving: false,
      specTypesNum:0,//规格类型保存个数
    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.pageData.total / this.pageData.limit))
    },
    pageNums() {
      const total = this.totalPages
      const nums = []
      const start = Math.max(1, Math.min(this.pageData.page - 2, total - 4))
      for (let i = start; i <= Math.min(total, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    },
    allChecked() {
      return this.list.length > 0 && this.ids.length === this.list.length
    }
  },
  created() {
    this.getList()
  },
  methods: {
    ...mapActions({
      getCelveData: 'ucenter/getCelveData',
      saveCelveData: 'ucenter/saveCelveData',
      opDelCelve: 'ucenter/opDelCelve'
    }),
    onPageSizeChange(size) {
      this.pageData.limit = size
      this.pageData.page = 1
      this.getList(true, 1)
    },
    getList(showLoading = true, page) {
      if (page) this.pageData.page = page
      if (showLoading) this.isLoading = true
      const param = { page_size: this.pageData.limit, page: this.pageData.page }
      Object.assign(param, this.searchData)
      this.getCelveData({
        data: param,
        success: (res) => {
          this.isLoading = false
          if (res.code === 200) {
            this.list = res.data.list || []
            this.pageData.total = res.data.total || 0
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    toggleOne(id) {
      const idx = this.ids.indexOf(id)
      if (idx > -1) this.ids.splice(idx, 1)
      else this.ids.push(id)
    },
    toggleAll() {
      if (this.allChecked) this.ids = []
      else this.ids = this.list.map(item => item.id)
    },
    batchDelStrategry() {
      if (!this.ids.length) {
        this.$message.warning('请选择要删除的策略')
        return false
      }
      this.delStrategry()
    },
    delStrategry(row) {
      this.$confirm('确定操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const ids = row && row.id ? [row.id] : this.ids
        this.opDelCelve({
          data: { ids },
          success: (res) => {
            this.isLoading = false
            if (res.code === 200) {
              this.$message.success(res.message)
              this.ids = []
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }).catch(() => {})
    },
    strategryOpen(row) {
      if (row) {
        this.strategy = { ...this.init_strategy, ...row }
        this.strategy.alibaba_non_free_postage_mode = this.strategy.alibaba_region_freight_enabled ? 'region' : (this.strategy.alibaba_non_free_postage_enabled ? 'fixed' : '')
        this.strategy.spec_types = this.strategy.spec_types ? JSON.parse(this.strategy.spec_types) : []
        this.specTypesNum=this.strategy.spec_types.length || 0
      } else {
        this.strategy = { ...this.init_strategy }
        this.specTypesNum = 0
      }
      this.formDialog = true
    },
    closeMask() {
      this.strategy = this.init_strategy
      this.formDialog = false
    },
    addSpecType() {
      if (!this.strategy.spec_types) this.strategy.spec_types = []
      if (this.strategy.spec_types.length >= 5) {
        this.$message.warning('最多只能添加5个商品规格类型')
        return
      }
      this.strategy.spec_types.push({
        sku_suffix: '',
        price_factor: 1.00,
        price_operator: '+',
        price_offset: 0,
        rounding_mode: 0
      })
    },
    removeSpecType(index) {
      this.$delete(this.strategy.spec_types, index)
    },
    handleAlibabaNonFreePostageModeChange() {
      this.strategy.alibaba_non_free_postage_enabled = this.strategy.alibaba_non_free_postage_mode === 'fixed'
      this.strategy.alibaba_region_freight_enabled = this.strategy.alibaba_non_free_postage_mode === 'region'
    },
    fenJiaoLabel(val){
      const index = this.fenjiao_options.findIndex(i=>i.value==val)
      return index>-1?this.fenjiao_options[index].label:''
    },
    saveEdit() {
      if (!this.strategy.name) {
        this.$message.info('请输入策略名称！')
        return false
      }
      const moneyPattern = /^\d+(\.\d{1,2})?$/
      this.handleAlibabaNonFreePostageModeChange()
      if (this.strategy.alibaba_non_free_postage_enabled) {
        if (!moneyPattern.test(String(this.strategy.alibaba_non_free_postage_amount)) || Number(this.strategy.alibaba_non_free_postage_amount) <= 0) {
          this.$message.info('1688不包邮加价金额必须大于0且最多保留两位小数！')
          return false
        }
      }
      if (this.strategy.alibaba_region_freight_enabled) {
        if (!this.provinceOptions.some(item => item.value === this.strategy.alibaba_region_freight_province_code)) {
          this.$message.info('请选择有效的发往省份！')
          return false
        }
        if (!moneyPattern.test(String(this.strategy.alibaba_region_freight_percent)) || Number(this.strategy.alibaba_region_freight_percent) < 0 || Number(this.strategy.alibaba_region_freight_percent) > 1000) {
          this.$message.info('指定地区运费比例必须为0到1000且最多保留两位小数！')
          return false
        }
        if (!moneyPattern.test(String(this.strategy.alibaba_region_freight_amount)) || Number(this.strategy.alibaba_region_freight_amount) < 0) {
          this.$message.info('指定地区固定加价必须大于等于0且最多保留两位小数！')
          return false
        }
      }
      if (this.strategy.alibaba_free_postage_low_price_enabled) {
        if (!moneyPattern.test(String(this.strategy.alibaba_free_postage_low_price_threshold)) || Number(this.strategy.alibaba_free_postage_low_price_threshold) <= 0) {
          this.$message.info('1688包邮低价SKU阈值必须大于0且最多保留两位小数！')
          return false
        }
        if (!moneyPattern.test(String(this.strategy.alibaba_free_postage_low_price_amount)) || Number(this.strategy.alibaba_free_postage_low_price_amount) <= 0) {
          this.$message.info('1688包邮低价SKU加价金额必须大于0且最多保留两位小数！')
          return false
        }
      }
      this.saving = true
      const params = { ...this.strategy }
      params.spec_types = JSON.stringify(params.spec_types)
      this.saveCelveData({
        data: params,
        success: (res) => {
          this.saving = false
          if (res.code === 200) {
            this.$message.success(res.message)
            this.formDialog = false
            this.getList()
          } else {
            this.$message.error(res.message)
          }
          this.isLoading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.gx-strat__row{
  display: flex;
  align-items: center;
  gap: 8px;
}


.gx-strat__spacer {
  flex: 1;
}
.gx-strat__selcount {
  font-size: 12px;
  color: #D4A946;
}
.gx-strat__btn {
  height: 32px;
  padding: 0px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  font-weight: 400;
  background: #FFFFFF;
  border: 1px solid rgba(212, 169, 70, .2);
  color: #4A4A6A;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: all .16s;
}
.gx-strat__btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-strat__btn--sm{
  height: 28px;
  padding: 0 12px;
  border-radius: 5px;
  font-size: 12px;
}
.gx-strat__btn--primary {
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border: none;
  font-weight: 600;
  color: #F4F6F8;
}
.gx-strat__btn--add {
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(224, 88, 88));
  border: none;
  font-weight: 600;
  color: #ffffff;
}
.gx-strat__btn--del {
  background: rgba(248, 113, 113, 0.07);
  border: 1px solid rgb(255, 204, 199);
  color: rgb(248, 113, 113);
}
.gx-strat__btn--info{
  background: rgb(204, 204, 204);
  color: rgb(255, 255, 255);
}
.gx-strat__btn--cancel{
  border: 2px solid rgb(224, 224, 236);
  color: #666666;
}
.gx-strat__table {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #E1E5EE;
  margin-bottom: 16px;
  background: #FFFFFF;
}
.gx-strat__table table {
  width: 100%;
  border-collapse: collapse;
}
.gx-strat__table th {
  padding: 10px 14px;
  text-align: left;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: rgb(102, 102, 102);
  border-bottom: 1px solid rgb(224, 224, 236);
  letter-spacing: 0.04em;
  background: rgb(245, 240, 232);
}
.gx-strat__table td {
  padding: 12px 14px;
  font-size: 12px;
  color: rgb(153, 153, 153);
  border-top: 1px solid rgba(212, 169, 70, .07);
}
.gx-strat__check {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  cursor: pointer;
  background: rgb(255, 255, 255);
  border: 1.5px solid rgb(224, 224, 236);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.gx-strat__check--on {
  background: rgb(200, 68, 60);
  border: 1.5px solid rgb(200, 68, 60);
}
.gx-strat__name {
  font-size: 13px;
  font-weight: 500;
  color: rgb(26, 26, 46);
}
.gx-strat__mono {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
}
.gx-strat__dim {
  color: #6A6A8A;
}
.gx-strat__default{
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(82, 196, 26);
}
.gx-strat__default_txt{
  padding: 1px 8px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgb(225, 229, 238), rgba(232, 199, 120, 0.1));
  border: 1px solid rgba(212, 169, 70, 0.4);
  font-family: "Noto Sans SC", sans-serif;
  font-size: 10px;
  font-weight: 600;
  color: rgb(212, 169, 70);
  width: fit-content;
  margin-left: 5px;
}

.gx-strat__default-dot{
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgb(82, 196, 26);
  display: inline-block;
}

.gx-strat__ops {
  display: flex;
  gap: 6px;
}
.gx-strat__op {
  height: 26px;
  padding: 0 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 11px;
  border: 1px solid;
  transition: all .16s;
}
.gx-strat__op--edit {
  background: #E6F4FF;
  border-color: #91CAFF;
  color: #1677FF;
}
.gx-strat__op--edit:hover {
  background: #1677FF;
  color: #fff;
}
.gx-strat__op--del {
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  color: rgb(200,68,60);
}
.gx-strat__op--del:hover {
  background: rgb(200,68,60);
  color: #fff;
}
.gx-strat__empty {
  text-align: center;
  padding: 52px 0 !important;
  color: #6A6A8A;
}
.gx-strat__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.%s__pager-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.gx-strat__modal-box--lg {
  max-width: 760px;
}
.gx-strat__modal-foot {
  margin: 0;
  padding: 12px 18px;
  border-top: 1px solid rgb(224, 224, 236);
  background: rgb(245, 240, 232)
}

.gx-strat__form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.gx-strat__field:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
.gx-strat__field-label {
  display: flex;
  align-items: baseline;
  gap: 5px;
  margin-bottom: 7px;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  color: rgb(102, 102, 102);
  letter-spacing: 0.06em;
}
.gx-strat__field-label--suffix{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 10px;
  color: rgb(153, 153, 153);
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0px;
}
.gx-strat__req {
  color: rgb(200, 68, 60);
  font-size: 12px;
}
.gx-strat__field-input {
  width: 100%;
  height: 34px;
  padding: 0 12px;
  border-radius: 7px;
  border: 1px solid rgb(224, 224, 236);
  font-size: 13px;
  color: #1A1A2E;
  outline: none;
  box-sizing: border-box;
}
.gx-strat__field-tip {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  color: rgb(153, 153, 153);
  margin-top: 5px;
}
.gx-strat__field-default{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: rgb(26, 26, 46);
  margin-bottom: 3px;
}
.gx-strat__field-warn{
  display: flex;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  background: rgb(255, 247, 230);
  border: 1px solid rgb(255, 213, 145);
  margin-top: 8px;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  color: rgb(102, 102, 102);
}
.gx-strat__tip--red {
  color: rgb(200,68,60);
}
.gx-strat__formula {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 13px;
  color: rgb(26, 26, 46);
}
.gx-strat__formula--card{
  padding: 12px 14px;
  border-radius: 8px;
  background: rgb(245, 240, 232);
  border: 2px solid rgb(224, 224, 236);
}
.gx-strat__formula-input-label{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 10px;
  color: rgb(153, 153, 153);
  margin-bottom: 3px;
  text-align: center;
}
.gx-strat__mini-input {
  width: 72px;
  height: 32px;
  padding: 0px 8px;
  border: 2px solid rgb(224, 224, 236);
  border-radius: 5px;
  outline: none;
  font-family: "JetBrains Mono", monospace;
  font-size: 14px;
  font-weight: 700;
  color: rgb(200, 68, 60);
  text-align: center;
  box-sizing: border-box;
}

.gx-strat__mini-input:disabled {
  background: #F5F6FA;
  color: #909399;
  cursor: not-allowed;
}
.gx-strat__formula--sm .gx-strat__mini-input{
  width: 64px;
  height: 28px;
  padding: 0 6px;
  border: 1px solid rgb(224, 224, 236);
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
}

.gx-strat__mini-select{
  width: 52px;
}
.gx-strat__mini-select :deep(.el-input__inner){
  height: 30px;
  padding: 0 8px;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(224, 224, 236);
  border-radius: 4px;
  font-size: 12px;
  color: rgb(26, 26, 46);
}
.gx-strat__postage {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.gx-strat__postage-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  font-size: 13px;
  color: #1A1A2E;
}
.gx-strat__radio {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 13px;
  color: #1A1A2E;
  user-select: none;
}
.gx-strat__radio input[type='radio'],
.gx-strat__radio-btn input[type='radio'] {
  display: none
}

.gx-strat__radio-group {
  display: flex;
  gap: 18px;
  flex-wrap: wrap;
  align-items: center;
}
.gx-strat__radio-btn{
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
  padding: 6px 14px;
  border-radius: 6px;
  background: rgb(245, 240, 232);
  border: 1.5px solid rgb(224, 224, 236);
  transition: 0.18s;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  color: rgb(26, 26, 46);
}
.gx-strat__radio-dot{
  width: 13px;
  height: 13px;
  border-radius: 50%;
  border: 2px solid rgb(224, 224, 236);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gx-strat__radio-btn.gx-strat__radio--on{
  background: rgb(255, 245, 245);
  border: 1.5px solid rgb(200, 68, 60);
  color: rgb(200, 68, 60);
}
.gx-strat__radio--on .gx-strat__radio-dot{
  border-color: rgb(200, 68, 60);
  position: relative;
}
.gx-strat__radio--on .gx-strat__radio-dot::after{
  content: "";
  position: absolute;
  top:2px;
  left: 2px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgb(200, 68, 60);
}

.gx-strat__help {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #E1E5EE;
  color: #6A6A8A;
  font-size: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: help;
  flex-shrink: 0;
}
.gx-strat__check {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.gx-strat__check input[type='checkbox'] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.gx-strat__check-box {
  width: 14px;
  height: 14px;
  border-radius: 4px;
  border: 1.5px solid rgb(224, 224, 236);
  box-sizing: border-box;
  background: #FFFFFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all .15s;
}
.gx-strat__check--on .gx-strat__check-box {
  background:rgb(200, 68, 60);
  border-color: transparent;
}

.gx-strat__sku-item {
  padding: 12px 14px;
  border-radius: 8px;
  border: 2px solid rgb(200, 68, 60);
  background: rgb(255, 245, 245);
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 5px;
  margin-top: 5px;
}
.gx-strat__sku-item--ed {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 9px 12px;
  border-radius: 6px;
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  margin-bottom: 5px;
  margin-top: 5px;
}
.gx-strat__sku-head {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 3px;
}
.gx-strat__sku-title {
  font-family: "Noto Serif SC", serif;
  font-size: 12px;
  font-weight: 700;
  color: rgb(200, 68, 60);
}
.gx-strat__sku-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.gx-strat__sku-label {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(102, 102, 102);
  width: 80px;
  flex-shrink: 0;
}
.gx-strat__sku-row .gx-strat__field-input {
  flex: 1 1 0%;
  height: 28px;
  padding: 0 8px;
  border: 1px solid rgb(224, 224, 236);
  border-radius: 4px;
  outline: none;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(26, 26, 46);
}

.gx-strat__sku-radio-group{
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.gx-strat__sku-radio{
  height: 26px;
  line-height: 24px;
  padding: 0px 10px;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  color: rgb(200, 68, 60);
  font-weight: 400;
  transition: 0.15s;
}
.gx-strat__sku-radio--on{
  background: rgb(200, 68, 60);
  border: 1px solid rgb(200, 68, 60);
  color: rgb(255, 255, 255);
  font-weight: 600;
}
.gx-strat__sku-tag{
  font-family: "JetBrains Mono", monospace;
  font-size: 10px;
  color: rgb(153, 153, 153);
  padding: 1px 5px;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.04);
  border: 1px solid rgb(224, 224, 236);
}
.gx-strat__switch {
  position: relative;
  display: inline-flex;
  cursor: pointer;
}
.gx-strat__switch input {
  display: none;
}
.gx-strat__switch-track {
  width: 40px;
  height: 22px;
  border-radius: 11px;
  background: rgba(0, 0, 0, 0.15);
  position: relative;
  transition: background .2s;
}
.gx-strat__switch-track::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #FFFFFF;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .2);
  transition: transform .2s;
}
.gx-strat__switch input:checked + .gx-strat__switch-track {
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(224, 88, 88));
  box-shadow: rgba(255, 77, 79, 0.3) 0px 0px 8px;
}
.gx-strat__switch input:checked + .gx-strat__switch-track::after {
  transform: translateX(18px);
}
</style>
